export const dateRangeSchema = {
    displayName: 'date range',
    type: 'object',
    fields: {
        from: {
            type: 'timestamp',
            required: true,
        },
        to: {
            type: 'timestamp',
            required: true,
        },
    },
};
//# sourceMappingURL=date_range_schema.js.map